import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Map slug → target month (and year) for the 3 main campaign sessions
const SLUG_TO_MONTH = {
  septembre: { month: 9, year: 2026, label: "Septembre 2026" },
  octobre:   { month: 10, year: 2026, label: "Octobre 2026" },
  novembre:  { month: 11, year: 2026, label: "Novembre 2026" },
};

export default function AtelierShortLink() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const target = SLUG_TO_MONTH[String(slug || "").toLowerCase()];
    if (!target) {
      setError("Session inconnue.");
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const { data: sessions } = await axios.get(`${API}/sessions`);
        // Pick first session whose date falls in target month/year & still open
        const match = sessions.find((s) => {
          if (!s.date) return false;
          const [y, m] = s.date.split("-").map(Number);
          return y === target.year && m === target.month;
        });
        if (cancelled) return;
        if (!match) {
          setError(`Aucune session disponible pour ${target.label}.`);
          return;
        }
        // Replace history so the back button skips this redirect page
        navigate(`/atelier/reservation/${match.id}`, { replace: true });
      } catch (e) {
        if (!cancelled) setError("Impossible de charger la session, réessaie dans un instant.");
      }
    })();
    return () => { cancelled = true; };
  }, [slug, navigate]);

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center px-6" data-testid="atelier-shortlink-loading">
      <div className="text-center max-w-md">
        <div className="font-serif text-3xl italic text-accent-light">Studio Euclides</div>
        <p className="eyebrow text-accent-deep mt-6">L'Atelier Lumière</p>
        {!error ? (
          <>
            <p className="mt-4 text-text-cream/70 font-light">On prépare ta session…</p>
            <div className="mt-6 inline-block h-8 w-8 border-2 border-accent-light/30 border-t-accent-light rounded-full animate-spin"></div>
          </>
        ) : (
          <>
            <p className="mt-4 text-text-cream/80 font-light">{error}</p>
            <Link to="/atelier" className="btn-primary inline-flex mt-8" data-testid="back-to-atelier">
              Voir toutes les sessions
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
